import { render, staticRenderFns } from "./_Keywordrole.vue?vue&type=template&id=77f3559e&scoped=true"
import script from "./_Keywordrole.vue?vue&type=script&lang=js"
export * from "./_Keywordrole.vue?vue&type=script&lang=js"
import style0 from "./_Keywordrole.vue?vue&type=style&index=0&id=77f3559e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f3559e",
  null
  
)

export default component.exports